import * as React from 'react'
import styled from 'styled-components'

import { useFiltersState } from '~/hooks/use-filters-state'
import Checkbox from '~/truck/checkbox'
import type { IProductFilerListType, IProductFilter } from '~/types/product-filters'

export interface FilterItemListsProps {
  productFilter: IProductFilter
}

const StyledCheckbox = styled(Checkbox)`
  display: block;
  padding: ${props => props.theme.spacing.cozy}px ${props => props.theme.spacing.comfortable}px;

  & > span {
    font-size: ${props => props.theme.spacing.cozy * 1.75}px;
  }
`

export function FilterItemLists(props: FilterItemListsProps) {
  const { productFilter } = props

  const { toggleListFilterValue } = useFiltersState()

  return (
    <>
      {productFilter.values.map((productFilterValue: IProductFilerListType) => {
        return (
          <StyledCheckbox
            color="primary"
            key={productFilterValue.key}
            checked={productFilterValue.selected}
            onChange={() => toggleListFilterValue(productFilterValue.serializedFilter)}
            textStyle="h6Regular"
          >
            {productFilterValue.label}
          </StyledCheckbox>
        )
      })}
    </>
  )
}
